module.exports = __webpack_public_path__ + "static/media/Graphics_3.095e2aae.png";